import AdbImage from './src/adb-image.vue';

AdbImage.install = function (Vue) {
  Vue.component(AdbImage.name, AdbImage);
};

export default AdbImage;
